import CustomOccupationDropdown from 'features/pii/components/FormPIIProfilePersonalDetails/components/CustomOccupationDropdown';
import {
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_FIELD,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME,
  RESET_PII_PROFILE_PERSONAL_DETAILS,
} from 'features/pii/const';
import withConfirmCancelFormEditModal from 'features/profileKYC/HOCs/withConfirmCancelFormEditModal';
import useProfileKYC from 'features/profileKYC/hooks/useProfileKYC';
import useProfileKYCStore from 'features/profileKYC/hooks/useProfileKYCStore';
import useOccupation from 'hooks/occupation/useOccupation';
import useHiddenSection from 'hooks/useHiddenOnlyFirst';
import useLang from 'hooks/useLang';
import React, { useImperativeHandle, useRef } from 'react';
import FormEditItemExpandable from '../FormEditItemExpandable';

const FormEditItemExpandableExt = withConfirmCancelFormEditModal(
  FormEditItemExpandable
);

const initialFormField = {
  ...RESET_PII_PROFILE_PERSONAL_DETAILS,
};

const INDEX = 2;

const FormEditOccupation = ({
  ref,
  currentEdit,
  setCurrentEdit,
  information,
  setInformation,
  validation,
  setValidation,
  checkFormInputValidation,
  isNextButtonDisabled,
}) => {
  const { t } = useLang();

  const {
    profileOccupation,
    getFormProfileKYCPersonalDetails,
    setFormProfileKYCInformation,
  } = useProfileKYCStore();
  const formProfileKYCPersonalDetailsStore = getFormProfileKYCPersonalDetails();

  const {
    checkPersonalDetailsProfileOccupationChange,
    checkPersonalDetailsProfilePrevOccupationChange,
  } = useProfileKYC();
  const currentProfileOccupation =
    information[PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME];
  const currentProfilePrevOccupation =
    information[PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME];
  const profileOccupationStore =
    formProfileKYCPersonalDetailsStore[
      PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME
    ];
  const profilePrevOccupationStore =
    formProfileKYCPersonalDetailsStore[
      PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME
    ];

  const isPersonalDetailsProfileOccupationInformationChange =
    checkPersonalDetailsProfileOccupationChange(
      currentProfileOccupation?.key,
      profileOccupation?.job?.key
    );
  const isPersonalDetailsProfileOccupationStoreChange =
    checkPersonalDetailsProfileOccupationChange(
      currentProfileOccupation?.key,
      profileOccupationStore?.key
    );
  const isPersonalDetailsProfilePrevOccupationStoreChange =
    checkPersonalDetailsProfilePrevOccupationChange(
      currentProfilePrevOccupation?.key,
      profilePrevOccupationStore?.key
    );

  const { checkShowPreviousOccupationField } = useOccupation();
  const isShowPreviousOccupationField = checkShowPreviousOccupationField(
    currentProfileOccupation?.key
  );

  const isShowRestOfOccupation = useHiddenSection({
    isHiddenOnlyFirst: false,
    isShow:
      isPersonalDetailsProfileOccupationInformationChange &&
      isShowPreviousOccupationField,
    deps: [
      isPersonalDetailsProfileOccupationInformationChange,
      isShowPreviousOccupationField,
    ],
  });
  useImperativeHandle(ref, () => ({}), []);

  const formEditItemExpandableRef = useRef();
  const { setExpand } = formEditItemExpandableRef?.current || {};

  const resetValidation = () => {
    const newValidation = {
      ...validation,
      ...initialFormField,
    };
    console.log(
      `⭐ FormEditOccupation 👉 resetValidation ➡️ newValidation ↩`,
      newValidation
    );
    setValidation(newValidation);
  };

  const renderRestOfOccupation = () => {
    return (
      <>
        <CustomOccupationDropdown
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
          isShowRestOfOccupation={isShowRestOfOccupation}
        />
      </>
    );
  };

  const handleOnOpenFormEditItemExpandable = () => {
    console.log(
      `⭐ FormEditPersonalDetails 👉 handleOnOpenFormEditItemExpandable ➡️ CLICKED ↩`
    );
    resetValidation();
    setCurrentEdit(INDEX);
  };
  const handleOnCloseFormEditItemExpandable = () => {
    const newInformation = {
      ...formProfileKYCPersonalDetailsStore,
    };
    console.log(
      `⭐ FormEditOccupation 👉 handleOnCloseFormEditItemExpandable ➡️ newInformation ↩`,
      newInformation
    );
    setInformation(newInformation);
    resetValidation();
    setCurrentEdit(-1);
    setExpand(false);
  };

  const handleOnUpdateFormEditItemExpandable = () => {
    let newInformation = { ...information };
    let newValidation = { ...validation };

    console.log(
      `⭐ FormEditOccupation 👉 handleOnUpdateFormEditItemExpandable ➡️ isNextButtonDisabled ↩`,
      isNextButtonDisabled
    );
    if (isNextButtonDisabled) {
      if (isShowRestOfOccupation) {
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME],
          PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_FIELD,
          newInformation,
          newValidation
        );
      }
      console.log(
        `⭐ FormEditOccupation 👉 handleOnUpdateFormEditItemExpandable ➡️ newValidation ↩`,
        newValidation
      );
      setValidation(newValidation);
      return false;
    }
    newInformation = {
      ...newInformation,
      ...(isPersonalDetailsProfileOccupationInformationChange
        ? {
            ...(isShowPreviousOccupationField
              ? {}
              : {
                  [PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME]: '',
                }),
          }
        : {}),
    };
    console.log(
      `⭐ FormEditOccupation 👉 handleOnUpdateFormEditItemExpandable ➡️ newInformation ↩`,
      newInformation
    );
    setInformation(newInformation);
    setFormProfileKYCInformation(newInformation);
    setCurrentEdit(-1);
    return true;
  };

  return (
    <FormEditItemExpandableExt
      ref={formEditItemExpandableRef}
      label={t('label_profile_kyc_occupation')}
      value={currentProfileOccupation?.key}
      note={t('')}
      onOpen={handleOnOpenFormEditItemExpandable}
      onUpdate={handleOnUpdateFormEditItemExpandable}
      isDisabled={currentEdit !== -1 && currentEdit !== INDEX}
      isChange={
        isPersonalDetailsProfileOccupationStoreChange ||
        isPersonalDetailsProfilePrevOccupationStoreChange
      }
      onCloseFormEditItemExpandable={handleOnCloseFormEditItemExpandable}
    >
      {renderRestOfOccupation()}
    </FormEditItemExpandableExt>
  );
};

export default FormEditOccupation;
